module.exports = "https://www.gc-pro.gnp.com.mx/9d0c03c5dd9c28354b87d4d6a01675c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/renovacion-via-nomina.png
// module id = 8163
// module chunks = 0